import { render } from "./FilterTokoByCode.vue?vue&type=template&id=e880b556"
import script from "./FilterTokoByCode.vue?vue&type=script&lang=js"
export * from "./FilterTokoByCode.vue?vue&type=script&lang=js"
script.render = render

export default script